import Vue from 'vue';
import { createPinia, PiniaVuePlugin } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { defineNuxtPlugin } from '~/.nuxt/imports';

Vue.use(PiniaVuePlugin);

export default defineNuxtPlugin((nuxtApp) => {
  const { app } = nuxtApp.nuxt2Context;

  const pinia = createPinia();
  // pinia-plugin-persistedstate resolves its default `storage` option eagerly
  // (`window.localStorage`) the moment any persist:true store is first
  // created — including during SSR, where `window` doesn't exist. There's
  // nothing to persist on the server anyway (no localStorage, and every SSR
  // request gets a fresh store), so only wire the plugin in on the client.
  if (process.client) {
    pinia.use(piniaPluginPersistedstate);
  }

  app.pinia = pinia;

  // VUE 2.7 WORKAROUND — see composables/usePinia.ts for the full
  // explanation and what to do with this at the Vue 3 flip.
  // Also provide it through Nuxt's own injection mechanism (a plain
  // `$root.$options.$pinia` property read, not Vue's Composition API
  // inject()), since that's what composables/usePinia.ts resolves.
  nuxtApp.provide('pinia', pinia);
});
